import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import StatsStrip from '../components/StatsStrip';
import Categories from '../components/Categories';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import Footer from '../components/Footer';
import PhoneCaptureModal from '../components/PhoneCaptureModal';
import { useAuth } from '../context/AuthContext';

const Home = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const openOnboarding = () => {
    if (user && !user.onboarded) navigate('/onboarding');
    else if (user) navigate('/dashboard');
    else navigate('/auth/signup');
  };
  const openLogin = () => {
    if (user) navigate('/dashboard');
    else navigate('/auth/login');
  };

  useEffect(() => {
    const openOnb = () => openOnboarding();
    window.addEventListener('open-onboarding', openOnb);
    return () => window.removeEventListener('open-onboarding', openOnb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="min-h-screen text-[#F5EDE0]">
      <Header onGetStarted={openOnboarding} onLogin={openLogin} />
      <main>
        <Hero onOpenOnboarding={openOnboarding} onOpenAuth={openLogin} />
        <StatsStrip />
        <Categories />
        <HowItWorks />
        <Pricing onOpenOnboarding={openOnboarding} />
        <Testimonials />
        <CTA onOpenOnboarding={openOnboarding} />
      </main>
      <Footer />
      <PhoneCaptureModal />
    </div>
  );
};

export default Home;
